export const ALERT_DEFAULT_TEXT = 'هل أنت متأكد؟';
export const CANCEL = 'إلغاء';

export const UPLOAD = 'رفع ملفات';
export const DROP_HERE = 'اسقط ملفات';
export const CONNECTING = 'جاري الاتصال...';

export const MONTHS = ['كانون الثاني', 'شباط', 'اذار', 'نيسان', 'ايار', 'حزيران', 'تموز', 'اب', 'ايلول', 'تشرين الاول', 'تشرين الثاني', 'كانون الاول'];
export const SHORT_MONTHS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
export const DAYS = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
export const SHORT_DAYS = ['ح', 'ثن', 'ثل', 'ر', 'خ', 'ج', 'س'];
export const GO_TO_TODAY = 'اذهب إلى اليوم';
export const AND = 'و';
export const MORE = 'أكثر';
export const NOW = 'الآن';
export const YESTERDAY = 'الأمس';
export const TODAY = 'اليوم';
export const ERR_FETCH_FILE_TITLE = 'فشل فتح الملف';
export const ERR_FETCH_FILE_TXT = 'هنال خطأ ما في الملف الذي تم اختياره';
export const CAMERA_ROLL_PERMISSION = 'الرجاء منح صلاحية الدخول الى معرض الصور من أجل اتمام العملية';
export const DIAL_CODE = 'رمز الاتصال';
export const PHOTOS = 'الصور';
export const VIDEOS = 'الفيديوهات';
export const CONFIRM = 'تأكيد';
export const SELECT_DATE = 'اختيار تاريخ';
export const YES = 'نعم';
export const CONFIRMA_REMOVE_ITEM = item => `هل أنت متأكد من حذف ${item}؟`;



// WEBPACK FOOTER //
// ./src/lang/ar/core.js